export enum ORGANIZATION_STATUS{
  pendingRequest="pending_request",
  pendingActivation="pending_approval",
  suspended="suspended",
  banned="banned",
  disabled="disabled",
  // approved="approved"
}